import { Skeleton } from '@/components/Skeleton';
import { useDevice } from '@/hooks/device';

export const HeaderSkeleton = () => {
  const { isMobileDevice } = useDevice();

  if (isMobileDevice)
    return (
      <Skeleton.Container gap={8}>
        <Skeleton.Rect height={40} rounded width={45} />
        <Skeleton.Container gap={8}>
          <Skeleton.Rect height={40} rounded />
          <Skeleton.Rect height={40} rounded />
        </Skeleton.Container>
      </Skeleton.Container>
    );

  return (
    <Skeleton.Container gap={8}>
      <Skeleton.Rect height={48} rounded width={100} />
      <Skeleton.Rect height={48} rounded width={100} />
      <Skeleton.Rect height={48} rounded width={84} />
      <Skeleton.Rect height={48} rounded width={48} />
    </Skeleton.Container>
  );
};
